import type { ButtonHTMLAttributes, FC } from 'react';
import React from 'react';
import { LinkButtonStyled } from '@components/atoms/link/styles';
import cn from 'classnames';

type LinkButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    dashed?: boolean;
};

export const LinkButton: FC<LinkButtonProps> = ({
    dashed,
    className,
    type = 'button',
    ...rest
}) => <LinkButtonStyled type={type} className={cn({ dashed }, className)} {...rest} />;
